var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMessage)?_c('alert-message',_vm._b({on:{"close":_vm.hide}},'alert-message',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }